export default __webpack_public_path__ + "static/anulu-c927f889b49178c29c1ee4bcdc49aa5d.webp";